/* sucrase/dist/esm/parser/traverser/base.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.getNextContextId = getNextContextId;
    exports.augmentError = augmentError;
    exports.locationForIndex = locationForIndex;
    exports.initParser = initParser;
    const tslib_1 = require("tslib");
    const state_1 = tslib_1.__importDefault(require("eda46439d5") /* ../tokenizer/state */);
    const charcodes_1 = require("22746c8ce8") /* ../util/charcodes */;
    function getNextContextId() {
        return exports.nextContextId++;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function augmentError(error) {
        if ("pos" in error) {
            const loc = locationForIndex(error.pos);
            error.message += ` (${loc.line}:${loc.column})`;
            error.loc = loc;
        }
        return error;
    }
    class Loc {
        constructor(line, column) {
            this.line = line;
            this.column = column;
        }
    }
    exports.Loc = Loc;
    function locationForIndex(pos) {
        let line = 1;
        let column = 1;
        for (let i = 0; i < pos; i++) {
            if (exports.input.charCodeAt(i) === charcodes_1.charCodes.lineFeed) {
                line++;
                column = 1;
            }
            else {
                column++;
            }
        }
        return new Loc(line, column);
    }
    function initParser(inputCode, isJSXEnabledArg, isTypeScriptEnabledArg, isFlowEnabledArg) {
        exports.input = inputCode;
        exports.state = new state_1.default();
        exports.nextContextId = 1;
        exports.isJSXEnabled = isJSXEnabledArg;
        exports.isTypeScriptEnabled = isTypeScriptEnabledArg;
        exports.isFlowEnabled = isFlowEnabledArg;
    }
}
